import whyusContent from '@content/whyus.yaml'
import type { WhyUsContent } from '@/types/content'

const content = whyusContent as unknown as WhyUsContent

export function WhyUs() {
  return (
    <section className="ss">
      <div className="ey reveal">{content.eyebrow}</div>
      <h2 className="sh2 reveal d2" dangerouslySetInnerHTML={{ __html: content.headline }} />
      <p className="slead reveal d3">{content.lead}</p>
      <div className="diff-grid">
        {content.cards.map((card, i) => (
          <div key={card.title} className={`diff-card reveal${i === 1 ? ' d2' : i === 2 ? ' d3' : ''}`}>
            <div className={`diff-icon ${card.iconClass}`}>{card.icon}</div>
            <h3 className="diff-title">{card.title}</h3>
            <p className="diff-body">{card.body}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
